import { post,put,del,get,get2 } from './axios'

// 관리자관리 CRUD를 나열
export const planCombo = async (params) => {
    const { status, data } = await get("/plans/planComboAjax", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const planList = async (params) => {
    const { status, data } = await get("/plans/selectPlansListAjax", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};

export const planDetail = async (params) => {
    const { status, data } = await get("/plans/selectPlansDetailAjax", params);
  
    if (status === 200 || status === 201) {
      return data;
    }
};


export const updatePlan = async (params) => {
  const { status, data } = await post("/plans/updatePlansAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const insertPlan = async (params) => {
  const { status, data } = await post("/plans/insertPlansAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const updateInactStatus = async (params) => {
  const { status, data } = await post("/user/updateInactStatusAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}